import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import api from '@/api';
import store from '@/store/index';
import util from '@/libs/util';
export default {
  namespaced: true,
  state: {
    appListAllData: [],
    appLoginTypeRes: [],
    appPaymentTypeAllData: [],
    appGatewayChannelListAllData: []
  },
  actions: {
    /**
     * @description 登录初始化数据
     */
    init: function init(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load: function load(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, dispatch, apiList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref3.state, dispatch = _ref3.dispatch;

                if (util.cookies.get('token')) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                apiList = ['appListAllData', 'appLoginTypeRes', 'appPaymentTypeAllData', 'appGatewayChannelListAllData'];
                apiList.forEach( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(i) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return dispatch('d2admin/db/get', {
                              dbName: 'sys',
                              path: "init.".concat(i),
                              defaultValue: [],
                              user: true
                            }, {
                              root: true
                            });

                          case 2:
                            state[i] = _context2.sent;

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 获取数据 type 获取数据类型
    getDataList: function getDataList(_ref5, type) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var state, dispatch, apiList, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = _ref5.state, dispatch = _ref5.dispatch;

                if (util.cookies.get('token')) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                if (type) {
                  _context5.next = 8;
                  break;
                }

                apiList = ['appListAllData', 'appLoginTypeRes', 'appPaymentTypeAllData', 'appGatewayChannelListAllData'];
                apiList.forEach( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(i) {
                    var data;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return api[i]();

                          case 2:
                            data = _context4.sent.data;
                            state[i] = data;
                            dispatch('d2admin/db/set', {
                              dbName: 'sys',
                              path: "init.".concat(i),
                              value: data,
                              user: true
                            }, {
                              root: true
                            });

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x4) {
                    return _ref6.apply(this, arguments);
                  };
                }());
                _context5.next = 13;
                break;

              case 8:
                _context5.next = 10;
                return api[type]();

              case 10:
                data = _context5.sent.data;
                state[type] = data;
                dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: "init.".concat(type),
                  value: data,
                  user: true
                }, {
                  root: true
                });

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  mutations: {
    /**
     * @description 设置全局游戏类型
     */
    setGameTypeList: function setGameTypeList(state, data) {
      state.GameTypeList = data;
    },

    /**
     * @description 设置当前选择的全局游戏类型
     */
    setGameTypeId: function setGameTypeId(state, data) {
      state.GameTypeId = data;
    }
  }
};